import { FrameName } from "../config";
import AbstractPoiTileEntity from "./AbstractPoiTileEntity";

class MonumentMegalithic3PoiTileEntity extends AbstractPoiTileEntity {
	public static readonly frameName = FrameName.MONUMENT_MEGALITHIC3;
}

export default MonumentMegalithic3PoiTileEntity;
